export default __webpack_public_path__ + "static/media/ldo_FIX_BIAS_EN.d3a052c9.svg";